import { render } from "./IconLiveBroadcast.vue?vue&type=template&id=6d1107d4"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconLiveBroadcast.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d1107d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d1107d4', __exports__)) {
    api.reload('6d1107d4', __exports__)
  }
  
  module.hot.accept("./IconLiveBroadcast.vue?vue&type=template&id=6d1107d4", () => {
    api.rerender('6d1107d4', render)
  })

}


export default __exports__